import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { BackIcon } from '../../../../../assets/icons/iconshere'
import { BreadLeftArrow, BreadRightArrow, CancelIcon, SearchesCIcon } from '../../../../../SvgIconsData'
import { defaultLogo } from '../../../../../env';
import axios from 'axios';
import { humanReadable } from '../../../../../utils/useWindowDimensions';

const TimesPlayedDetailed = () => {
    const userData = useSelector((state) => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    const navigate = useNavigate();
    const params = useParams();    
    const location = useLocation();
    const { group, module } = location.state;
    const {groupId, resourceId} = params;
    const [search, setSearch] = useState("");
    const [list, setList] = useState([]);


    const getUserModuleAttemptList = async() =>{
        try {
            let { data } = await axios.get(`${configData.config.API_URL}/api/analytics/user/module/attempt/list/${groupId}/${resourceId}`,{
                headers: {
                    Authorization: `Bearer ${userData.token}`,
                    "Content-Type": "application/json",
                  }
            });
            setList(data.data);
            
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
             if(groupId) getUserModuleAttemptList();
    },[groupId]);



  return (
    <>
        <div className="container-fluid dashboard p-4 pt-2 pb-2 bg-grey-main">
        <div className='col-12 d-flex align-items-center justify-content-start mt-2'>
            <div className="nav-btw">
            <span onClick={() => navigate(-1)}>
            <BreadLeftArrow />
            </span>
            </div>
            <div className="breadcrums">
                <span>
                <span>  {group} </span>
                <BreadRightArrow />
                </span>
                <span>
                <span>  {module} </span>
                <BreadRightArrow />
                </span>
                <span className='active'>
                <span> Times Played </span>
                </span>
            </div>
        </div>


         <div className='col-12 d-flex align-items-center justify-content-end'>
            <span className="d-flex align-items-center justify-content-center gap-2">
                    <form className=" app-search app-search1 d-flex justify-content-end ">
                        <div className="position-relative">
                        <SearchesCIcon />
                        {search.length > 0 && (
                            <span className="searchiconcancel" onClick={() => setSearch("")}>
                            <CancelIcon />
                            </span>
                        )}
                        <input
                            type="text"
                            value={search}
                            name="searchName"
                            className="form-control"
                            placeholder="Search"
                            autoComplete="off"
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        </div>
                    </form>
            </span>
         </div>

        <div className='col-12'>
        <div className="table-responsive workflowtb mt-2 stickyhead reports timesplayed">
            <table className="table align-middle table-nowrap mb-0">
            <thead>
            <tr>
                <th>
                    <div className="text-center">S.No.</div>
                </th>
                <th>
                    <div>User Name</div>
                </th>
                <th>
                    <div className="text-center">Count</div>
                </th>
                <th>
                    <div className="text-center">Total Time Spend</div>
                </th>
                <th>
                    <div className="text-center">Average Time Spend</div>
                </th>
            </tr>      
            </thead>
            <tbody>
                {list.length > 0 &&
                    list.map((item,index)=>{
                    if( !item.name.toLowerCase().includes(search.toLowerCase())) return;
                    let placeholderName = item.name.split(" ").slice(0,2).map(word => word[0].toUpperCase()).join("")
                    return(
                        <tr>
                            <td>
                                <div className="text-center"> {index+1}</div>
                            </td>
                            <td>
                                <div className='nameimage'>
                                    <span className='initials-placeholder'>{placeholderName}</span>
                                    {item.name}
                                </div>
                            </td>
                            <td>
                                <div className="text-center">{item.count}</div>
                            </td>
                            <td>
                                <div className="text-center">{humanReadable(item.total)}</div>
                            </td>
                            <td>
                                <div className="text-center">{humanReadable(item.average)}</div>
                            </td>
                        </tr>
                    )
                    })
                }                    
            </tbody>
            </table>
        </div>
            
        </div>
        </div>
    </>
  )
}

export default TimesPlayedDetailed
